module.exports = __webpack_public_path__ + "static/media/3.c01fe351.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/rhand/3.png
// module id = 1441
// module chunks = 0